import { EyeOff, UserCheck, Lock, Box, Headset, Star } from '../Icons';

const features = [
  { Icon: EyeOff, title: 'Privacy by design', text: 'Senders see journey and capacity, never full names, phone numbers or addresses. Details are revealed only after assignment.' },
  { Icon: UserCheck, title: 'Verified travellers', text: 'Identity and journey information are checked by our team before a traveller can be assigned any item.' },
  { Icon: Lock, title: 'Secure payments', text: 'Payments are processed on-platform and held until the admin confirms the assignment.' },
  { Icon: Box, title: 'Permitted items only', text: 'Every item is declared and screened against a clear list of what can and cannot be carried.' },
  { Icon: Star, title: 'Ratings & history', text: 'Completed trips and ratings build trust over time, so you can choose with confidence.' },
  { Icon: Headset, title: 'Human support', text: 'A real team oversees every assignment and is there to help if plans change.' },
];

export default function Safety() {
  return (
    <section className="section" id="safety">
      <div className="container">
        <div className="section__head reveal">
          <span className="kicker">Trust & safety</span>
          <h2>Built for peace of mind, on both ends</h2>
          <p>Handing your belongings to a stranger requires trust. We engineered the platform around it.</p>
        </div>

        <div className="bento">
          {features.map(({ Icon, title, text }, i) => (
            <article className={`tile reveal ${i === 0 ? 'tile--wide' : ''}`} key={title} style={{ '--delay': `${i * 60}ms` }}>
              <div className="tile__icon"><Icon /></div>
              <h3>{title}</h3>
              <p>{text}</p>
              {i === 0 && (
                <div className="privacy-demo" aria-hidden="true">
                  <div className="privacy-demo__row"><span>Route</span><strong>Mumbai → Dubai</strong></div>
                  <div className="privacy-demo__row"><span>Capacity</span><strong>8 kg</strong></div>
                  <div className="privacy-demo__row"><span>Name</span><strong className="masked">Aarav Mehta</strong></div>
                  <div className="privacy-demo__row"><span>Phone</span><strong className="masked">+91 98200 12345</strong></div>
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
